import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { AlertComponent } from './alert.component';
import { alertReducer } from './alert.reducer';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertContainerComponent } from './alert.container.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatIconModule,
    MatSnackBarModule,
    StoreModule.forFeature('alert', alertReducer),
  ],
  declarations: [AlertComponent, AlertContainerComponent],
  exports: [AlertContainerComponent],
})
export class AlertModule {}
